export class BackedUpByResourceType {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "data",
            "baseName": "data",
            "type": "Array<BackedUpByResourceTypeDataInner>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackedUpByResourceType.attributeTypeMap;
    }
    constructor() {
    }
}
